import { render } from "./AssignTraineeModal.vue?vue&type=template&id=673e178e&scoped=true"
import script from "./AssignTraineeModal.vue?vue&type=script&lang=js"
export * from "./AssignTraineeModal.vue?vue&type=script&lang=js"

import "./AssignTraineeModal.vue?vue&type=style&index=0&id=673e178e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-673e178e"]])

export default __exports__